import { PositiveColors, TextColors } from '@picsart/design-system/foundation/colors';
import { FontSizes, LineHeights } from '@picsart/design-system/foundation/typography';

import { FontWeights } from '@picsart/design-system/foundation/fonts';
import { Spacings } from '@picsart/design-system/foundation/spacings';
import { createUseStyles } from 'react-jss';
import { mediaQuery } from '@picsart/rc/helpers';
import { BreakPoints } from '@picsart/design-system/foundation/responsive';

const useStyles = createUseStyles(
  () => ({
    root: {
      padding: [Spacings.s56, Spacings.s0],

      [mediaQuery(BreakPoints.Large)]: {
        padding: [Spacings.s40, Spacings.s0],
      },

      // [mediaQuery(BreakPoints.Small)]: {
      '@media screen and (max-width: 766px)': {
        padding: [Spacings.s64, Spacings.s0],
      },

      // [mediaQuery(767)]: {
      '@media screen and (max-width: 767px)': {
        padding: [Spacings.s40, Spacings.s0],
      },
    },
    titleHolder: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      width: '100%',
      margin: [Spacings.s0, 'auto', Spacings.s48],

      '&:before, &:after': {
        content: "''",
        backgroundColor: PositiveColors.base.default,
        maxWidth: 546,
        display: 'inline-block',
        width: '-webkit-fill-available',
        height: 2,

        // [mediaQuery(BreakPoints.Small)]: {
        '@media screen and (max-width: 766px)': {
          display: 'none',
        },
      },

      // [mediaQuery(BreakPoints.Small)]: {
      '@media screen and (max-width: 766px)': {
        margin: [Spacings.s0, 'auto', Spacings.s32],
      },

      // [mediaQuery(767)]: {
      '@media screen and (max-width: 767px)': {
        margin: [Spacings.s0, 'auto', Spacings.s24],
      },
    },
    title: {
      display: '-webkit-box',
      minWidth: 350,
      margin: [Spacings.s0, 'auto'],
      '-webkit-line-clamp': 2,
      '-webkit-box-orient': 'vertical',
      fontSize: FontSizes.s30,
      fontWeight: FontWeights.semibold,
      textAlign: 'center',
      lineHeight: LineHeights.l48,
      color: TextColors.tint1,
      overflow: 'hidden',

      // [mediaQuery(BreakPoints.Small)]: {
      '@media screen and (max-width: 766px)': {
        '-webkit-line-clamp': 3,
      },

      // [mediaQuery(767)]: {
      '@media screen and (max-width: 767px)': {
        '-webkit-line-clamp': 4,
        fontSize: FontSizes.s24,
        lineHeight: LineHeights.l32,
      },
    },
    grid: {
      columnCount: 2,
      columnGap: Spacings.s24,
      pageBreakBefore: 'avoid',

      // [mediaQuery(766)]: {
      '@media screen and (max-width: 766px)': {
        columnCount: 1,
      },
    },

    //  SKELETON
    titleSkeleton: {
      height: 40,

      '& > i': {
        margin: [Spacings.s0, Spacings.s24],
      },
    },
    boxSkeleton: {
      '&.first': {
        height: 340,
      },
      '&.second': {
        height: 120,
      },
      '&.third': {
        height: 180,
      },
      '&.forth': {
        height: 280,
      },
    },
  }),
  {
    name: 'text-in-box-design',
  },
);

export default useStyles;
